export default __webpack_public_path__ + "static/media/admin.e0956132.png";